<cm-ui-dialog [title]="data.title" [closeLabel]="'common.close' | translate">
  <img class="su-lightbox-image" [src]="data.src" [alt]="data.title" />

  <ng-container footer-right>
    <cm-ui-standard-button rounded (onClick)="close()">{{ 'common.close' | translate }}</cm-ui-standard-button>
  </ng-container>
</cm-ui-dialog>
